export default __webpack_public_path__ + "static/media/work1.0a2e8430.png";